import { Button, ChannelAvatar, Flex, Text } from '@buffer-mono/popcorn'

import type { Channel } from '../../../../common/types'

import { getChannelSettingsRoute } from './constants'
import styles from './LinkedInCapabilities.module.css'

import type { JSX } from 'react'

type LinkedInProfileListProps = {
  onOpenProfileSettings: (channelId: string) => void
  profiles: Channel[]
}

export function LinkedInProfileList({
  onOpenProfileSettings,
  profiles,
}: LinkedInProfileListProps): JSX.Element {
  return (
    <ul className={styles.channelList}>
      {profiles.map((profile) => {
        const profileName = profile.name

        return (
          <li className={styles.channelItem} key={profile.id}>
            <ChannelAvatar
              alt=""
              channel="linkedin"
              fallback="letter"
              fallbackName={profileName}
              size="mid"
              src={profile.avatar}
            />
            <Flex className={styles.channelText} direction="column" gap="2xs">
              <Text className={styles.channelName} weight="medium">
                {profileName}
              </Text>
              <Text size="sm" color="subtle">
                Profile
              </Text>
            </Flex>
            <Button
              as="a"
              href={getChannelSettingsRoute(profile.id)}
              onClick={(): void => onOpenProfileSettings(profile.id)}
              size="small"
              variant="secondary"
            >
              Setup
            </Button>
          </li>
        )
      })}
    </ul>
  )
}
